import {
  FETCH_SCHEDULE_LOADING,
  FETCH_SCHEDULE_FAILED,
  FETCH_SCHEDULE_SUCCESS,
  FILTER_SCHEDULE_LOADING,
  FILTER_SCHEDULE_FAILED,
  FILTER_SCHEDULE_SUCCESS,
  ACTIVATE_SCHEDULE_FILTER,
} from '../actions/types';

const ERROR_FETCHING = 'Filme konnten nicht geladen werden.';
const ERROR_FILTERING = 'Filme konnten nicht gefiltert werden';

const INITIAL_STATE = {
  films: [],
  filteredFilms: [],
  availableFilter: [],
  activeFilter: null,
  settings: {},
  loading: true,
  error: '',
};

const updateActiveFilterState = (state, filter) => ({
  ...state,
  activeFilter: filter,
});

const updateErrorState = (state, error) => ({
  ...state,
  loading: false,
  error,
});

const updateLoadingState = (state) => ({
  ...state,
  loading: true,
  error: false,
});

const updateScheduleFetchedState = (state, payload) => {
  const { films, filters, activeFilter, settings } = payload;

  return {
    ...state,
    films,
    filteredFilms: films,
    availableFilter: filters,
    activeFilter,
    settings,
    loading: false,
    error: false,
  };
};

const updateScheduleFilteredState = (state, { filteredFilms }) => ({
  ...state,
  filteredFilms,
  loading: false,
  error: false,
});

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_SCHEDULE_LOADING:
    case FILTER_SCHEDULE_LOADING:
      return updateLoadingState(state);
    case FETCH_SCHEDULE_FAILED:
      return updateErrorState(state, ERROR_FETCHING);
    case FILTER_SCHEDULE_FAILED:
      return updateErrorState(state, ERROR_FILTERING);
    case FETCH_SCHEDULE_SUCCESS:
      return updateScheduleFetchedState(state, action.payload);
    case FILTER_SCHEDULE_SUCCESS:
      return updateScheduleFilteredState(state, action.payload);
    case ACTIVATE_SCHEDULE_FILTER:
      return updateActiveFilterState(state, action.payload);
    default:
      return state;
  }
};
